import { fieldValidationMessages } from 'app/constants';
import * as yup from 'yup';
import { SocietyOption } from './types';

export const idNameValidation = (maxLength: number, field?: string) => ({
  then: yup
    .string()
    .required(field === 'lastName' ? 'At least one name is required' : '')
    .max(maxLength, fieldValidationMessages.MAX_CHAR(maxLength)),
  otherwise: yup
    .string()
    .nullable()
    .max(maxLength, fieldValidationMessages.MAX_CHAR(maxLength)),
});

export const manualRequiredIdNameValidation = (maxLength: number) =>
  yup.string().when('society', {
    is: (society?: SocietyOption) => !society?.verification,
    ...idNameValidation(maxLength),
  });

export const oneOfRequiredIdNameValidation = (
  oneOfField: string,
  maxLength: number
) =>
  yup.string().when([oneOfField, 'society'], {
    is: (nameValue: string, society?: SocietyOption) =>
      !society?.verification && (!nameValue || nameValue.length === 0),
    ...idNameValidation(maxLength, oneOfField),
  });
